import { isEmpty, isNil } from "lodash";

import type { HavePermissionFn, IUser_Permission } from "./type";

export const havePermission: HavePermissionFn = ({ _recordPermission, record, isUnion }) => {
  if (!record || isEmpty(record)) {
    return true;
  }

  for (const [recordKey, recordFn] of Object.entries(record)) {
    const _recordValue =
      _recordPermission && typeof _recordPermission === "object" && recordKey in _recordPermission
        ? _recordPermission[recordKey]
        : null;

    if (isNil(_recordValue)) {
      if (isUnion) {
        continue;
      }

      return false;
    }

    const matched = recordFn(_recordValue as IUser_Permission);

    if (isUnion) {
      if (matched) {
        return true;
      }

      continue;
    }

    if (!matched) {
      return false;
    }
  }

  return !isUnion;
};
